import { render, staticRenderFns } from "./Download.vue?vue&type=template&id=21322b15&scoped=true"
import script from "./Download.vue?vue&type=script&lang=js"
export * from "./Download.vue?vue&type=script&lang=js"
import style0 from "./Download.vue?vue&type=style&index=0&id=21322b15&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21322b15",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21322b15')) {
      api.createRecord('21322b15', component.options)
    } else {
      api.reload('21322b15', component.options)
    }
    module.hot.accept("./Download.vue?vue&type=template&id=21322b15&scoped=true", function () {
      api.rerender('21322b15', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/elements/Download.vue"
export default component.exports